import React, { Component, Fragment } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardHeader, MDBCardBody } from 'mdb-react-ui-kit'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import PageHeading from '../../components/shared/PageHeading.component'
import EliteAgencyTeamsTab from './components/EliteAgencyTeamsTab/EliteAgencyTeamsTab.component'
import ReferralPartnersTab from './components/ReferralPartnersTab/ReferralPartnersTab.component'
import './CommissionPaymentsPage.scss'

class CommissionPaymentsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'elite-agency-teams',
    }
  }

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }

  renderTabContent = () => {
    const { activeTab } = this.state

    switch (activeTab) {
      case 'elite-agency-teams':
        return <EliteAgencyTeamsTab />
      case 'referral-partners':
        return <ReferralPartnersTab />
      default:
        return <EliteAgencyTeamsTab />
    }
  }

  render() {
    const { activeTab } = this.state

    return (
      <Fragment>
        <DashboardLayout>
          <main id='CommissionPaymentsPage' className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <PageHeading
                label='Commission Payments'
                url={this.props?.match?.url}
                from={this.props?.location?.state?.from}
                goTo={url => this.props.history.push(url, { from: '/commission-payments' })}
              />
            </MDBContainer>
            <MDBContainer fluid>
              <MDBRow>
                <MDBCol>
                  <MDBCard>
                    <MDBCardHeader color='indigo'>
                      <span
                        className={`profile-tab ${activeTab === 'elite-agency-teams' ? 'active' : ''}`}
                        onClick={() => this.toggleTab('elite-agency-teams')}
                      >
                        Elite Agency Teams
                      </span>
                      <span
                        className={`profile-tab ${activeTab === 'referral-partners' ? 'active' : ''}`}
                        onClick={() => this.toggleTab('referral-partners')}
                      >
                        Referral Partners
                      </span>
                    </MDBCardHeader>
                    <MDBCardBody className='mx-4 mt-4'>{this.renderTabContent()}</MDBCardBody>
                  </MDBCard>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default CommissionPaymentsPage
